import {useEffect} from 'react';
import {useEditorPrefetchVectorMobileModules} from '@Hooks/poster-editor/useEditorPrefetchVectorMobileModules';

export function useEditorPrefetchRectangleMobileModules(): void {
  useEditorPrefetchVectorMobileModules();

  useEffect((): void => {
    void prefetchVectorModules();
  }, []);

  const prefetchVectorModules = async (): Promise<void> => {
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-rectangle-rounding-panel');
  };
}
